import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lock16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M7.25 12V9.5H8.75V12H7.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.75 6.25V4.5C3.75 2.15279 5.65279 0.25 8 0.25C10.3472 0.25 12.25 2.15279 12.25 4.5V6.25H13.0417C13.7691 6.25 14.25 6.87241 14.25 7.5V14.5C14.25 15.1276 13.7691 15.75 13.0417 15.75H2.95833C2.23089 15.75 1.75 15.1276 1.75 14.5V7.5C1.75 6.87241 2.23089 6.25 2.95833 6.25H3.75ZM5.25 4.5C5.25 2.98122 6.48122 1.75 8 1.75C9.51878 1.75 10.75 2.98122 10.75 4.5V6.25H5.25V4.5ZM3.25 7.75V14.25H12.75V7.75H3.25Z'
      fill='currentColor'
    />
  </Svg>
);

Lock16.displayName = 'Lock16';
export default Lock16;
